export const Status = { NOT_STARTED: 'Not Started', IN_PROGRESS: 'In Progress', COMPLETED: 'Completed', SKIPPED: 'Skipped' };
export const Schedule = {
	'0 0 * * 1,2,3,4,5': { label: 'Mon-Fri', colour: '#6D4C9A', bgColour: '#EEE7F7' },
	'0 0 * * 1,3,5': { label: 'Mon/Wed/Fri', colour: '#A64D8F', bgColour: '#F5E4F0' },
	'0 0 * * 2,4': { label: 'Tue/Thu', colour: '#C65D16', bgColour: '#FCE8D9' },
	'0 0 * * 3,5': { label: 'Wed/Fri', colour: '#A64D8F', bgColour: '#F5E4F0' },
	'0 0 * * *': { label: 'Everyday', colour: '#4F5968', bgColour: '#E9EDF2' },
	'0 0 */2 * 1-5': { label: 'Every Other Day', colour: '#4F5968', bgColour: '#E9EDF2' },
	'0 0 * * 1': { label: 'Mondays', colour: '#39758A', bgColour: '#E2F0F4' },
	'0 0 * * 2': { label: 'Tuesdays', colour: '#C5303E', bgColour: '#FBE4E7' },
	'0 0 * * 3': { label: 'Wednesdays', colour: '#B35D18', bgColour: '#FBEBDD' },
	'0 0 * * 4': { label: 'Thursdays', colour: '#8A6A00', bgColour: '#FFF5CC' },
	'0 0 * * 5': { label: 'Fridays', colour: '#693477', bgColour: '#F1E3F3' },
}